import React, { Component } from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import FacebookProvider from 'react-facebook'
import Home from './components/Home'
import Header from './components/Header/Header'
import PostDetail from './components/Post/PostDetail'
import Pridat from './components/Pridat'
import { Premietania, About, Partneri, Contact, Gdpr } from './components/Static'
import { About89, Contact89, Home89, Premietania89, Partneri89 } from './components/89'
import cookiesConsent from './cookiesConsent'
import GATracker from './GATracker'
import './styles/index.css'

class App extends Component {
  componentDidMount() {
    cookiesConsent()
  }

  // eslint-disable-next-line
  componentDidCatch(error, info) {
    if (window.Raven) {
      window.Raven.captureException(error, { extra: info })
    }
  }

  render() {
    return (
      <FacebookProvider appId="279249649531573">
        <BrowserRouter>
          <div className="App">
            <Header />
            <GATracker />

            <section className="main">
              <Route exact path="/" component={Home} />
              <Route path="/prispevok/:slug" component={PostDetail} />
              <Route path="/pridat" component={Pridat} />
              <Route path="/partneri" component={Partneri} />
              <Route path="/premietania" component={Premietania} />
              <Route path="/o-projekte" component={About} />
              <Route path="/gdpr" component={Gdpr} />
              <Route path="/kontakt" component={Contact} />
            </section>
            <section className="main main-89">
              <Route exact path="/89" component={Home89} />
              <Route path="/89/prispevok/:slug" component={PostDetail} />
              <Route path="/89/pridat" component={Pridat} />
              <Route path="/89/partneri" component={Partneri89} />
              <Route path="/89/premietania" component={Premietania89} />
              <Route path="/89/o-projekte" component={About89} />
              <Route path="/89/kontakt" component={Contact89} />
            </section>
          </div>
        </BrowserRouter>
      </FacebookProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js